'use client';

import { usePathname } from 'next/navigation';
import { Avocado, Box, Stack } from '@instamenu/ui-system-next';
import * as styles from './Sidebar.css';
import { clsx } from 'clsx';
import { useDismissible } from '@instamenu/react-hooks';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from '@instamenu/ui-vanilla-extract';
import { NavItem } from './NavItem';
import { useNavigation } from './use-navigation';
import { useEffect } from 'react';
import { AiAssistantNav } from './AiAssistantNav';

export type SidebarProps = {
  handleMouseDown: (e: React.MouseEvent) => void;
  isMobileOpen: boolean;
  setIsMobileOpen: (value: boolean) => void;
};

export const Sidebar = (props: SidebarProps) => {
  const { handleMouseDown, isMobileOpen, setIsMobileOpen } = props;

  const routes = useNavigation();
  const pathname = usePathname();
  const isDesktop = useMediaQuery({ query: breakpoints.desktop });

  const { ref } = useDismissible(() => {
    if (!isDesktop) setIsMobileOpen(false);
  });

  useEffect(() => {
    if (!isDesktop) setIsMobileOpen(false);
  }, [isDesktop, setIsMobileOpen, pathname]);

  return (
    <Box
      ref={!isDesktop ? ref : undefined}
      className={clsx(!isDesktop && styles.mobileSidebar)}
      data-visible={!isDesktop ? isMobileOpen : true}
    >
      <Stack className={styles.container}>
        <Avocado className={styles.avocado} />
        <Stack className={styles.scrollableBox}>
          {routes.map((item) =>
            item.path === '/ai' ? (
              <AiAssistantNav key="ai-assistant" />
            ) : (
              <NavItem key={item.path} {...item} isActive={pathname === item.path} />
            ),
          )}
        </Stack>
      </Stack>
      {isDesktop && <Box className={styles.resizer} onMouseDown={handleMouseDown} />}
    </Box>
  );
};
